import React from 'react';
import styles from './ConfirmationModal.module.scss';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  cancelText?: string;
  confirmText?: string;
  customRender?: React.ReactNode;
  modalBodyStyle?: React.CSSProperties;
  modalHeaderStyle?: React.CSSProperties;
  modalContentStyle?: React.CSSProperties;
  modalButtonStyle?: React.CSSProperties;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "",
  message = "Are you sure you want to continue?",
  cancelText = "CANCEL",
  confirmText = "Continue",
  customRender,
  modalBodyStyle,
  modalHeaderStyle,
  modalContentStyle,
  modalButtonStyle
}) => {
  if (!isOpen) return null;

  return (
    <div style={{display: isOpen ? 'block' : 'none', position: 'relative'}}>
      <div className={styles.modalOverlay} onClick={onClose} />
      <div className={styles.optsWrapper}>
        <div style={modalContentStyle} className={styles.modalContent}>
          <div style={modalHeaderStyle} className={styles.modalHeader}>
            {title && <h3>{title}</h3>}
          </div>
          <div style={modalBodyStyle} className={styles.modalBody}>
            <p>{message}</p>
            {customRender}
          </div>
          <div className={styles.btnWrapper}>
            <button 
              onClick={onClose}
              style={{
                background: 'none',
                color: '#E64B37',
                fontSize: '20px',
                borderRadius: '10px',
                border: 'none'
              }}
            >
              <span>{cancelText}</span>
            </button>
          </div>
        </div>
      </div>

      <div style={modalButtonStyle} className={styles.doneWrapper}>
        <button 
          onClick={onConfirm}
          style={{
            background: 'none',
            color: '#4F7D9C',
            fontSize: '20px',
            margin: '5px',
            borderRadius: '10px',
            border: 'none'
          }}
        >
          {confirmText}
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal; 